import { ChangeDetectorRef, EventEmitter, OnChanges, OnDestroy, OnInit, SimpleChanges, } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IconColor, IconSize } from '@freelancer/ui/icon';
export var ListItemType;
(function (ListItemType) {
    ListItemType["NON_BORDERED"] = "non_bordered";
    ListItemType["CHECKBOX"] = "checkbox";
    ListItemType["DEFAULT"] = "default";
    ListItemType["DISMISS"] = "dismiss";
    ListItemType["RADIO"] = "radio";
    ListItemType["TOGGLE"] = "toggle";
    ListItemType["ORDERED"] = "ordered";
    ListItemType["UNORDERED"] = "unordered";
})(ListItemType || (ListItemType = {}));
export var ListItemPadding;
(function (ListItemPadding) {
    ListItemPadding["XXXSMALL"] = "xxxsmall";
    ListItemPadding["XXSMALL"] = "xxsmall";
    ListItemPadding["XSMALL"] = "xsmall";
    ListItemPadding["SMALL"] = "small";
    ListItemPadding["MID"] = "mid";
})(ListItemPadding || (ListItemPadding = {}));
export var ListItemInputAlignment;
(function (ListItemInputAlignment) {
    ListItemInputAlignment["TOP"] = "top";
    ListItemInputAlignment["CENTER"] = "middle";
})(ListItemInputAlignment || (ListItemInputAlignment = {}));
var ListItemHeaderComponent = /** @class */ (function () {
    function ListItemHeaderComponent() {
    }
    return ListItemHeaderComponent;
}());
export { ListItemHeaderComponent };
var ListItemBodyComponent = /** @class */ (function () {
    function ListItemBodyComponent() {
    }
    return ListItemBodyComponent;
}());
export { ListItemBodyComponent };
var ListItemComponent = /** @class */ (function () {
    function ListItemComponent(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        // Imported types
        this.ListItemType = ListItemType;
        this.IconColor = IconColor;
        this.IconSize = IconSize;
        // Host bindings
        this.ariaRole = 'listitem';
        // Inputs
        /** Mandatory for Checkbox, Radio and Toggle; optional for any expandable or selectable item */
        this.control = new FormControl(false);
        // Inputs passed from `List`
        this.type = ListItemType.DEFAULT;
        this.clickable = false;
        this.expandable = false;
        this.selectable = false;
        this.padding = ListItemPadding.XSMALL;
        this.bodyEdgeToEdge = false;
        this.outerPadding = true;
        this.first = false;
        this.last = false;
        this.bottomBorder = false;
        this.indent = false;
        /** Form Input (radio, checkbox, toggle) alignment */
        this.inputAlignment = ListItemInputAlignment.CENTER;
        // Outputs
        this.dismiss = new EventEmitter();
        this.headerClicked = new EventEmitter();
    }
    ListItemComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.controlSubscription = this.control.valueChanges.subscribe(function (_) {
            _this.changeDetectorRef.markForCheck();
        });
    };
    ListItemComponent.prototype.ngOnChanges = function (changes) {
        if (!this.outerPadding && (this.isFormInput() || this.clickable)) {
            throw new Error('Lists with a hover state must have outer padding!');
        }
    };
    ListItemComponent.prototype.ngOnDestroy = function () {
        if (this.controlSubscription) {
            this.controlSubscription.unsubscribe();
        }
    };
    ListItemComponent.prototype.onClick = function (event) {
        // not a clickable thing: only emit headerClicked.
        if (!this.isFormInput() && !this.clickable) {
            this.headerClicked.emit(event);
            return;
        }
        if (this.control.enabled) {
            // if we're given a radioValue, we treat the control like a radio
            if (this.radioValue !== undefined) {
                this.control.setValue(this.radioValue);
            }
            else {
                this.control.setValue(!this.control.value);
            }
        }
    };
    Object.defineProperty(ListItemComponent.prototype, "active", {
        get: function () {
            // if we're given a radioValue, we treat the control like a radio
            return this.radioValue !== undefined
                ? this.control.value === this.radioValue
                : this.control.value;
        },
        enumerable: true,
        configurable: true
    });
    ListItemComponent.prototype.isFormInput = function () {
        return [
            ListItemType.RADIO,
            ListItemType.CHECKBOX,
            ListItemType.TOGGLE,
        ].includes(this.type);
    };
    ListItemComponent.prototype.onDismiss = function () {
        this.dismiss.emit();
    };
    return ListItemComponent;
}());
export { ListItemComponent };
